import { useState, useEffect } from "react";
import api from '../../api/axios';
import './newsslider.css';

const Slider = () => {

    const [currentSlide, setCurrentSlide] = useState(1);
    const [pictures, setPictures] = useState([]);
    const totalSlides = 3;
    
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide === totalSlides ? 1 : prevSlide + 1));
        }, 7500);

        return () => clearInterval(intervalId); // Cleanup on unmount
    }, [currentSlide]);

    useEffect(() => {
        const fetchPictures = async () => {
            try {
                const response = await api.get("/user/websitepictures");
                setPictures(response.data);
            } catch (err) {
                console.error("Error fetching website pictures:", err);
            }
        };
        fetchPictures();
    }, []);

    const handleManualChange = (slideNumber) => {
        setCurrentSlide(slideNumber);
    };

    return (
        <div className="newsslider">
            <div className="slides">    
                {pictures.length > 0 && pictures.map((pic, index) => (
                    <div key={index} className={`home-txt ${currentSlide === index + 1 ? 'active' : ''}`} id={`slide${index + 1}`}>
                        <img src={pic} alt={`Slide ${index + 1}`} />
                    </div>
                ))}
                {/* Radio buttons for manual navigation */}
                <div className="buttons-container">
                    {pictures.map((_, index) => (
                        <input
                            key={index}
                            type="radio"
                            className="btn-class"
                            checked={currentSlide === index + 1}
                            onChange={() => handleManualChange(index + 1)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Slider;